import api from "./api";

// ----------- Login -----------
export const login = async (username, password) => {
  try {
    const res = await api.post("/auth/token/", { username, password });

    localStorage.setItem("access_token", res.data.access);
    localStorage.setItem("refresh_token", res.data.refresh);

    return res.data;
  } catch (err) {
    console.error("Login error:", err.response || err);
    throw err;
  }
};

// ----------- Logout -----------
export const logout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("username");
  localStorage.removeItem("user_role");

  window.location.href = "/login"; // optional: redirect to login page
};

// ----------- Get Access Token -----------
export const getAccessToken = () => localStorage.getItem("access_token");

// ----------- Check if Authenticated -----------
export const isAuthenticated = () => !!getAccessToken();

// ----------- Refresh Access Token -----------
export const refreshAccessToken = async () => {
  const refresh = localStorage.getItem("refresh_token");
  if (!refresh) {
    logout();
    throw new Error("No refresh token available");
  }

  try {
    const res = await api.post("/auth/token/refresh/", { refresh });
    localStorage.setItem("access_token", res.data.access);
    return res.data.access;
  } catch (err) {
    logout(); // refresh failed → force logout
    throw err;
  }
};
